import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import TextArea from 'fuse-ui/components/TextArea';
import Typography from 'fuse-ui/components/Typography';

import Warning from '../../../common/components/warning';
import PropTypes from 'prop-types';

import { DOMAIN_ACTION_TYPES, DOMAIN_ACTION_WARNING_MESSAGES } from './constants';

const styles = theme => ( {
    container: {
        display: 'flex',
        flexDirection: 'column'
    },
    domainTypes: {
        marginTop: theme.spacing.unit * 2,
    },
    textArea: {
        marginTop: theme.spacing.unit * 2,
    },
} );

const DOMAIN_TYPES_MAP = {
    add: true,
    changeType: true,
    remove: false,
    undefined: false,
};

const DomainManagementBulkTypesRadioButton = ( {
    classes,
    selectedAction,
    domainListErrorMessage,
    domainTypes,
    onChange,
    textAreaValue
} ) => {
    return (
        <div className={classes.container}>
            <Typography className={classes.spacing} variant="subtitle1" color="textPrimary" gutterBottom>
                { DOMAIN_ACTION_TYPES[selectedAction] }
            </Typography>
            {
                DOMAIN_ACTION_WARNING_MESSAGES[selectedAction] &&
                ( <Warning noPadding>
                    { DOMAIN_ACTION_WARNING_MESSAGES[selectedAction] }
                </Warning> )
            }
            {
                DOMAIN_TYPES_MAP[selectedAction] &&
                ( <div className={classes.domainTypes}>
                    { domainTypes }
                </div> )
            }
            <TextArea
                className={classes.textArea}
                data-automation-id="manage-in-bulk-side-panel-domain-list"
                error={!!domainListErrorMessage}
                helperText={domainListErrorMessage ? domainListErrorMessage : 'Press Enter from your keyboard for a new line'}
                label="Apply to the following domains"
                onChange={onChange}
                placeholder="You can copy and paste domains here; make sure you've got one domain per line"
                value={textAreaValue}
            />
        </div>
    );
};

DomainManagementBulkTypesRadioButton.propTypes = {
    classes: PropTypes.object,
    domainListErrorMessage: PropTypes.string,
    domainTypes: PropTypes.node,
    onChange: PropTypes.func,
    selectedAction: PropTypes.oneOf( ['add','changeType', 'remove'] ).isRequired,
    textAreaValue: PropTypes.string,
};

export default withStyles( styles )( DomainManagementBulkTypesRadioButton );
